import styled from 'styled-components';

export const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(15.5rem, 1fr));
  justify-items: center;
  gap: 0.5rem;
  width: 100%;

  @media (max-width: 1100px) {
    grid-template-columns: repeat(auto-fill, minmax(13.5rem, 1fr));
  }

  @media (max-width: 470px) {
    grid-template-columns: repeat(auto-fill, minmax(11.5rem, 1fr));
  }
`;
